import { Component, Directive, OnInit, ViewEncapsulation, OnDestroy, Inject, forwardRef } from '@angular/core';
import { NgIf } from '@angular/common';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { LoginDTO } from '../../domain/dto/loginDto';

import { GrowlModule, Message } from 'primeng/primeng';
// Necesario para mostrar mensajes con esta plantilla
import {TranslatePipe, TranslateService, LangChangeEvent} from 'ng2-translate';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControlName } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { getToken } from '../../app.module';
import { AppComponent } from '../../app.component';

// Probar cuando venga Pablo de vacaciones, si se activa resolveJsonModule en tsconfig peta la compilacion aot como le pasaba a appciudadano
// import * as packageJson from '../../../../package.json';
import { Constantes } from '../../domain/constantes';

@Component({
	templateUrl: './Login.component.html'
})

export class LoginComponent implements OnInit {
	spinner: HTMLElement;
	blockUI: HTMLElement;
	logado: boolean;

	showLogin: boolean = false;
	showRecuperarPassword: boolean = false;
	showNewPassword: boolean = false;
	correoEnviado: boolean = false;

	token: string;
	model: LoginDTO;

	msgs: Message[] = [];

	loading: boolean;

	color: string;
	mode: string;

	formLogin: FormGroup;
	formNewPass: FormGroup;

	newPass: string = '';
	newPassConfirm: string = '';

	version: string = '1.4.0.10'; // packageJson.version;
	logo: string;
	titulo_logo: string;
	recuperacion: string;
	entidadParam: string;
	loginParam: string;
	constructor(
		private appComponent: AppComponent,
		public translate: TranslateService,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private router: Router,
		private route: ActivatedRoute, )
	{
		console.log('*** LoginComponent ***');
		this.loading = false;
		this.color = 'primary';
		this.mode = 'indeterminate';
		this.model = new LoginDTO();
		this.model.entidad = '';
		this.model.user = '';
		this.model.password = '';
		this.logo = Constantes.LOGO;
		this.titulo_logo = Constantes.TITULO_LOGO;
		this.recuperacion = "0";
		this.entidadParam = '';
		this.loginParam = '';

		this.formLogin = new FormGroup({
			'entidad': new FormControl('', [
				Validators.required,
				Validators.minLength(3)
			]),
			'user': new FormControl('', [
				Validators.required,
				Validators.minLength(3)
			]),
			'pass': new FormControl('', [
				Validators.required,
				Validators.minLength(3)
			])
		});

		this.formNewPass = new FormGroup({
			'newPass': new FormControl('', [
				Validators.required,
				Validators.minLength(3)
			]),
			'newPassConfirm': new FormControl('', [
				Validators.required,
				Validators.minLength(3)
			])
		});

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';

		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';
	}

	ngOnInit() {
		window.scroll(0, 0);
		this.showLogin = true;
		this.showRecuperarPassword = false;
		this.showNewPassword = false;
		this.correoEnviado = false;
		this.logo = Constantes.LOGO;
		this.route.params
		.subscribe(params => {
			this.token = params['id'];
			this.recuperacion = params['recuperacion'];
			this.entidadParam = params['entidad'];
			this.loginParam = params['login'];

			// si vienen ambas variables, se le setean directamente
			if(this.entidadParam && this.loginParam){
				this.model.entidad = this.entidadParam;
				this.model.user = this.loginParam;
			}
			if (this.token) {
				this.showLogin = false;
				this.showRecuperarPassword = false;
				this.showNewPassword = true;
				this.correoEnviado = false;
			}
			else if(this.recuperacion === "1" && this.entidadParam && this.loginParam){
				this.showLogin = false;
				this.showRecuperarPassword = true;
				this.showNewPassword = false;
				this.correoEnviado = false;
			}
			else{
				if (this.authService.isAuthenticated()){
					this.showLogin = false;
					this.showRecuperarPassword = false;
					this.showNewPassword = false;
					this.correoEnviado = false;
					this.router.navigate(['/espacios']);
				}
				else{
					const that = this;
					const token = that.authService.getToken();
					const sesionCaducada = that.authService.estaTokenExpirado();

					if (token && sesionCaducada) {
						that.delay(100)
						.then(function(){
							that.appComponent.showError('Su sesión ha caducado.');
						});
					}

					that.showLogin = true;
					that.showRecuperarPassword = false;
					that.showNewPassword = false;
					that.correoEnviado = false;

					const tipo_logo = params['logo'];
					if (tipo_logo === '1') {
						//Constantes.LOGO = '../assets/layout/images/ITSN.png';
						that.logo = Constantes.LOGO;
						that.titulo_logo = Constantes.TITULO_LOGO;
					}
					else if (tipo_logo === '2') {
						Constantes.LOGO = '../assets/layout/images/ITSN2.png';
						that.logo = Constantes.LOGO;
						that.titulo_logo = 'Login.navegacioninteriores2';
					}
					else {
						// Si no es ni uno ni dos dejo el logo que ya se habia seteado o el que estubiera por defecto
					}
				}
			}

		});
	}

	async delay(ms: number) {
		return new Promise( resolve => setTimeout(resolve, ms) );
	}

	loginApp() {
		// console.log('LOGIN !!!');
		const that = this;
		this.spinner.style.display = 'inherit';
		this.loading = true;
		// this.recuperacion,
		this.authService.login(this.model.entidad, this.model.user, this.model.password)
		.then(function (data) {
			that.loading = false;
			console.log(data);
			if ((data.res === 1) && (data.lista.length > 0)) {
				// that.model.entidad = '';
				// that.model.user = '';
				// that.model.password = '';
				// Ocultamos Spinner
				// that.spinner.style.display = 'none';
				that.router.navigate(['/espacios']);
			}
			else {
				// Ocultamos Spinner
				that.spinner.style.display = 'none';
				that.model.error = data.msg;
				if(data.res === -75){ // Contraseña caducada
					that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_CONTRASENIA_CADUCADA'));
				}
				else{
					that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_LOGIN'));
				}

			}
		})
		.catch(function (error) {
			// Ocultamos Spinner
			that.spinner.style.display = 'none';
			that.model.error = error;
			that.appComponent.showError(error);
		});
	}

	cancelarRecureparPassword(){
		this.showLogin = true;
		this.showRecuperarPassword = false;
		this.showNewPassword = false;
		this.correoEnviado = false;
	}

	mostrarRecureparPassword(){
		if (this.model.entidad.length > 0 && this.model.user.length > 0) {
			this.showLogin = false;
			this.showRecuperarPassword = true;
			this.showNewPassword = false;
			this.correoEnviado = false;
		}
		else{
			this.appComponent.showError(this.translate.instant('MensajesEmergentes.MENSAJE_ERROR_PASSWORD_RECUPERAR_NO_USER'));
		}
	}

	mostrarNewPassword(){
		this.showLogin = false;
		this.showRecuperarPassword = false;
		this.showNewPassword = true;
		this.correoEnviado = false;
	}

	ocultarNewPassword(){
		this.showLogin = true;
		this.showRecuperarPassword = false;
		this.showNewPassword = false;
		this.correoEnviado = false;
	}

	mostrarCorreoEnviado(){
		this.showLogin = false;
		this.showRecuperarPassword = false;
		this.showNewPassword = false;
		this.correoEnviado = true;
	}

	ocultarCorreoEnviado(){
		this.showLogin = true;
		this.showRecuperarPassword = false;
		this.showNewPassword = false;
		this.correoEnviado = false;
	}

	enviarEmailPassword(){
		this.spinner.style.display = 'inherit';
		const that = this;
		this.sws.wsRecordarPassword(this.model.entidad, this.model.user).toPromise()
		.then(function (data) {
			that.spinner.style.display = 'none';
			that.mostrarCorreoEnviado();
			return data;
		})
		.catch(e => {
			this.spinner.style.display = 'none';
			this.appComponent.showError(this.translate.instant('MensajesEmergentes.MENSAJE_ERROR_NO_POSIBLE_PASSWORD_RECUPERAR'));
			throw e;
		});
	}

	confirmarPassword(){
		const that = this;
		if (this.newPass === this.newPassConfirm) {
			this.spinner.style.display = 'inherit';
			this.sws.wsConfirmarPassword(this.token, this.model.entidad, this.model.user, this.newPass, this.newPassConfirm).toPromise()
			.then(function (data) {
				that.spinner.style.display = 'none';
				that.mostrarCorreoEnviado();
				return data;
			})
			.catch(e => {
				this.spinner.style.display = 'none';
				this.appComponent.showError(this.translate.instant('MensajesEmergentes.MENSAJE_ERROR_NO_POSIBLE_PASSWORD_CONFIRMAR'));
				console.error(e);
				throw e;
			});
		}
		else{
			this.appComponent.showError(this.translate.instant('MensajesEmergentes.MENSAJE_ERROR_NO_POSIBLE_PASSWORD_CONFIRMAR_DIFERENTES'));
		}

	}

	/* **  Gestion Mensajes ** */
	protected showError = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'error',  detail: mensaje});
	}

	protected showSuccess = (mensaje) => {
		this.msgs = [];
		this.msgs.push({severity: 'success',  detail: mensaje});
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Login/Login.component.ts